export default __webpack_public_path__ + "static/media/chefjase.063b3062.png";